// Date-aware application windows + recruitment phases.
// QA override: append ?asof=YYYY-MM-DD to any URL to preview a date.
const D = (s) => new Date(`${s}T00:00:00`);
const DAY = 86400000;

export const getNow = () => {
  try {
    const asof = new URLSearchParams(window.location.search).get("asof");
    if (asof && /^\d{4}-\d{2}-\d{2}$/.test(asof)) return D(asof);
  } catch {}
  return new Date();
};

const WINDOWS = {
  student: { open: "2026-09-05", lastDay: "2026-10-31", opensLabel: "September 5, 2026", closesLabel: "October 31, 2026", opensShort: "SEPTEMBER 5" },
  talent: { open: "2026-09-05", lastDay: "2026-10-31", opensLabel: "September 5, 2026", closesLabel: "October 31, 2026", opensShort: "SEPTEMBER 5" },
  brand: { open: "2026-11-01", lastDay: "2026-12-01", opensLabel: "November 1, 2026", closesLabel: "December 1, 2026", opensShort: "NOVEMBER 1" },
  mentor: { open: "2026-11-01", lastDay: "2026-12-01", opensLabel: "November 1, 2026", closesLabel: "December 1, 2026", opensShort: "NOVEMBER 1" },
  school: null,
};

// status: "open" | "sealed" (opens later) | "closed" (window passed)
export const windowState = (kind, now = getNow()) => {
  const w = WINDOWS[kind];
  if (!w) return { status: "open" };
  if (now < D(w.open)) return { ...w, status: "sealed" };
  if (now < new Date(D(w.lastDay).getTime() + DAY)) return { ...w, status: "open" };
  return { ...w, status: "closed" };
};

export const isWindowOpen = (kind, now = getNow()) => windowState(kind, now).status === "open";

export const PHASES = [
  { n: "I", code: "SURVEILLANCE", range: "August 24 – September 4", start: "2026-08-24", end: "2026-09-04", body: "The Architect is observing. Applicants can review mission requirements and prepare their files." },
  { n: "II", code: "RECRUITMENT", range: "September 5 – October 31", start: "2026-09-05", end: "2026-10-31", body: "Student + Creative applications are open. Submit your dossier before the window seals." },
  { n: "III", code: "NETWORK ACTIVATION", range: "November 1 – December 1", start: "2026-11-01", end: "2026-12-01", body: "Brand + Mentor applications are open. The network expands." },
  { n: "IV", code: "SELECTION", range: "December", start: "2026-12-02", end: "2026-12-31", body: "Applications are under review. Selected cohort members begin receiving their next instructions." },
];

export const activePhaseIndex = (now = getNow()) => {
  for (let i = 0; i < PHASES.length; i++) {
    if (now >= D(PHASES[i].start) && now < new Date(D(PHASES[i].end).getTime() + DAY)) return i;
  }
  return now < D(PHASES[0].start) ? -1 : PHASES.length;
};
